const SVG = ({ fill = "none", width = "20", height = "19", viewBox = "0 0 20 19" }) => (
  <svg width={width} height={height} viewBox={viewBox} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.6577 9C16.6577 13.14 13.2977 16.5 9.15765 16.5C5.01765 16.5 1.65765 13.14 1.65765 9C1.65765 4.86 5.01765 1.5 9.15765 1.5C13.2977 1.5 16.6577 4.86 16.6577 9Z"
      stroke="#7F7F7F"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M11.9403 11.3853L9.61531 9.99781C9.21031 9.75781 8.88031 9.18031 8.88031 8.70781V5.63281" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export default SVG;
